import { render, staticRenderFns } from "./EditAliasName.vue?vue&type=template&id=7dac0a1c&scoped=true"
import script from "./EditAliasName.vue?vue&type=script&lang=js"
export * from "./EditAliasName.vue?vue&type=script&lang=js"
import style0 from "./EditAliasName.vue?vue&type=style&index=0&id=7dac0a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac0a1c",
  null
  
)

export default component.exports